import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, useEntityManager } from 'elentari'
import analistaMercadoriaRepository from './AnalistaMercadoriaRepository'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'

const validate = data => {
  return {
    analistaId: data.analistaId ? undefined : 'Obrigatório'
  }
}

const AnalistaMercadoriaForm = props => {
  const entityManager = useEntityManager({
    repository: analistaMercadoriaRepository
  })
  const handleSubmit = data => {
    const mercadoriaId = parseInt(props.match.params.id)
    return entityManager.onSubmit({
      ...data,
      mercadoriaId
    })
  }
  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            label="Analista"
            name="analistaId"
            realm="analistaAdmin"
            component={UsuarioAutocomplete}
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default AnalistaMercadoriaForm
